const AUTHORITY_PREFIX = 'MBO_'
export const CAN_GET_SPONSOR_BANK_LIST = `${AUTHORITY_PREFIX}GET_SPONSOR_BANK_LIST`
export const CAN_TOGGLE_DYNAMIC_ACCOUNT_STATUS = `${AUTHORITY_PREFIX}TOGGLE_DYNAMIC_ACCOUNT_STATUS`
export const CAN_CREATE_MERCHANT = `${AUTHORITY_PREFIX}CREATE_MERCHANT`
export const CAN_VIEW_MERCHANTS = `${AUTHORITY_PREFIX}GET_MERCHANT_LIST`



// WEBPACK FOOTER //
// ./src/constants/authorities/index.js